/*
   Access API end point for managing user.
   This class is to be used within the *dealerManagement* modules.
 */
import {HttpUtils} from "@/api/common/HttpUtils";


export class DealerMgmtService {

    constructor(auth) {

        if (auth == null) {
            throw new Error("[e887287-ADM] Dealer Managemenet Service Error - Auth is missing!. ");
        }

        this._rootUrl = process.env.VUE_APP_API_URL;
        this._auth = auth;
        this._baseUrl = `${this._rootUrl}/v1/accounts`;
        this._baseDealersUrl = `${this._rootUrl}/v1/accounts/dealers`;
        this._headers = HttpUtils.getHttpHeaders(this._auth, 'text/json');
    }


    /**
     * Creates a new dealer account.
     * @param user
     * @returns {Promise<>}
     */
    createDealer(account, homeBranchId, companyId) {
        return new Promise((resolve, reject) => {

            if (account == null){
                throw new Error("[e383630-ADM] account not defined.")
            }

            if (homeBranchId == null){
                throw new Error("[e530209-ADM] homeBranchId not defined")
            }

            if (companyId == null){
                throw new Error("[e589754-ADM] companyId not defined")
            }

            let url = `${this._baseDealersUrl}`;

            let requestData = {
                account: account,
                homeBranch: homeBranchId,
                companyId: companyId,
            };

            HttpUtils.post(url, this._auth, requestData).then(data => {

                if (data == null){
                    // 404 error - it should not happen unless the API URL is wrong.
                    throw new Error("[e931246-ADM] Unexpected response. Api endpoint might be wrong. possible 404 error.");
                }

                if (data == true) {
                    resolve();
                }
                else{
                    reject();
                }
            }).catch(e => {

                window.tracer.error("[e70612] Server error when creating a new dealer account")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });

        });
    }

    /**
     * Updates a new dealer account.
     * @param user
     * @returns {Promise<>}
     */
    updateDealer(account, homeBranchId, companyId) {
        return new Promise((resolve, reject) => {

            if (account == null){
                throw new Error("[e960989-ADM] account not defined.")
            }

            if (homeBranchId == null){
                throw new Error("[e716564-ADM] homeBranchId not defined")
            }

            if (companyId == null){
                throw new Error("[e793763-ADM] companyId not defined")
            }

            let url = `${this._baseDealersUrl}`;

            let requestData = {
                account: account,
                homeBranch: homeBranchId,
                companyId: companyId,
            };

            HttpUtils.put(url, this._auth, requestData).then(data => {

                if (data == null){
                    // 404 error - it should not happen unless the API URL is wrong.
                    throw new Error("[e813061-ADM] Unexpected response. Api endpoint might be wrong. possible 404 error.");
                }

                if (data == true) {
                    resolve();
                }
                else{
                    reject();
                }
            }).catch(e => {

                window.tracer.error("[e70612-ADM] Server error when updating a new dealer account.")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });

        });
    }

    existsDealerAccount(account){

        return new Promise((resolve, reject) => {


            if (account == null || account.length === 0){
                window.tracer.warn("[w611429-ADM] Empty string or null as account number. Check caller. It is not allowed. Next statement will raise an error");
                throw new Error("[e763341-ADM] An empty string or null (undefined) as account number is not allowed");
            }

            let url = `${this._baseDealersUrl}/${account}`;

            HttpUtils.head(url, this._auth).then(data => {

                if (data == null) {
                    window.tracer.verbose(`[v399164-ADM] Result for ${account} is null, we interpret as the account does not exists. Value returned is false.`);

                    resolve(false);
                    return;
                }

                if (data == true) {
                    window.tracer.verbose(`[v399164-ADM] Result for ${account} is true, we interpret as the account *does* exists. Value returned is true.`);

                    resolve(true);
                    return;
                }
                else{
                    window.tracer.verbose(`[v399164-ADM] Result for ${account} is false, we interpret as the account does not exists. Value returned is true.`);

                    resolve(false);
                }
            }).catch(e => {

                window.tracer.error("[e296626-ADM] Server error when checking a dealer account exists.")
                if (e != null) {
                    window.tracer.error(e);
                }

                reject(e);
            });
        });
    }
}